import AnimateInView from '@atoms/AnimateInView/AnimateInView';
import Text from '@atoms/Text/Text';
import DisplayStyleEnum from '@models/enums/DisplayStyleEnum';
import SiteEnum from '@models/enums/SiteEnum';
import { IHotspotCard } from '@models/IHotspotCard';
import HotspotCard from '@molecules/HotspotCard/HotspotCard';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import { fadeInUp } from '@utility/config/animations';
import useMediaQuery from '@utility/hooks/useMediaQuery';
import { motion } from 'motion/react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly displayAs: DisplayStyleEnum;
  readonly items: IHotspotCard[];
  readonly subtext?: string;
  readonly title?: string;
}

const HotspotCards = ({ displayAs, items, title, subtext }: Props) => {
  const isMobile = useMediaQuery(752);

  const titleElement = (
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-2.5">
      <Text className="tw-text-black" variant="headline">
        {title}
      </Text>
      {subtext && (
        <Text variant="body" className="tw-text-grey-80">
          {subtext}
        </Text>
      )}
    </div>
  );

  if (displayAs === DisplayStyleEnum.Carousel)
    return (
      <NavigationCarousel
        site={SiteEnum.Deco}
        id={`${title}-content-items-carousel`}
        numberOfSlides={items.length}
        slidesToShowDesktop={3}
        titleElement={title ? titleElement : undefined}
      >
        {items.map((item) => (
          <SwiperSlide
            className="stretch-item tw-h-full"
            key={item.meta?.contentLink}
          >
            <HotspotCard {...item} />
          </SwiperSlide>
        ))}
      </NavigationCarousel>
    );

  return (
    <AnimateInView>
      {items.length > 2 && isMobile ? (
        <NavigationCarousel
          numberOfSlides={items.length}
          id={`hotspot-grid-${items[0]?.mobileImage?.meta?.contentLink ?? items[0]?.video?.videoSource}`}
          slidesToShowMobile={1.1}
          site={SiteEnum.Deco}
        >
          {items.map((item) => (
            <SwiperSlide
              key={item?.mobileImage?.url ?? item?.video?.videoSource}
              className="stretch-card tw-h-full"
            >
              <HotspotCard {...item} />
            </SwiperSlide>
          ))}
        </NavigationCarousel>
      ) : (
        <div className="tw-container">
          <div className="tw-flex tw-flex-col tw-gap-sm md:tw-flex-row md:tw-gap-md">
            {items.map((item) => (
              <motion.div
                key={
                  item?.mobileImage?.meta?.contentLink ??
                  item?.video?.meta?.contentLink
                }
                variants={fadeInUp}
                className="tw-flex-grow tw-basis-0"
              >
                <HotspotCard {...item} />
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </AnimateInView>
  );
};
export default HotspotCards;
